import React, { useEffect } from 'react';
import { OfferBar } from './components/OfferBar';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { PromptExplainer } from './components/PromptExplainer/PromptExplainer';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { ValueStack } from './components/ValueStack';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
const PAGE_TITLE = '100+ AI Prompts for 911 Dispatchers™ | SIGMA SMART';
const META_DESCRIPTION = '120 copy-and-paste AI prompts that help 911 dispatchers and telecommunicators finish CAD narratives, pass-downs, QA reviews and training paperwork before shift change.';
export function App() {
  useEffect(() => {
    document.title = PAGE_TITLE;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', META_DESCRIPTION);
  }, []);
  return <div className="min-h-full w-full overflow-x-hidden text-plum" data-id="element-0" data-mp="4n5w26l2pak">
      <MetaPixel data-id="element-1" data-mp="2zlldgx6hkckm" />
      <OfferBar data-id="element-2" data-mp="2zm4wkh7vh708" />
      {/* Spacer matching the fixed offer bar height */}
      <div className="h-[58px] sm:h-[68px]" aria-hidden="true" style={{
      paddingBottom: "29px"
    }} data-id="element-3" data-mp="33m5be2yvvk7t" />
      <main data-id="element-4" data-mp="38l8hzruihyhw">
        <Hero data-id="element-5" data-mp="38li7lebna3n2" />
        <Stats data-id="element-6" data-mp="38l053zye2t6p" />
        <Testimonials data-id="element-7" data-mp="38kgl8dp6huq1" />
        <PainPoints data-id="element-8" data-mp="38o4edbqpof48" />
        <Volumes data-id="element-9" data-mp="3dkl0k0ecojeo" />
        <Bonuses data-id="element-10" data-mp="3dl4jnkfqldua" />
        <Pricing data-id="element-11" data-mp="3dlnwimqj5c1g" />
        <PromptExplainer data-id="element-12" data-mp="3dm5vhr4ku4d2" />
        <FAQ data-id="element-13" data-mp="nvj3jfxq0epq" />
        <ValueStack data-id="element-14" data-mp="nw2a60hx7gog" />
      </main>
      <Footer data-id="element-15" data-mp="nur7y544igzg" />
    </div>;
}